module.exports = __webpack_public_path__ + "static/work14-090eb9e08ba0ab59bdd284da875af209.jpg";